import { Link, Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import {
  prescriptionTemplateQueryKeys,
  prescriptionTemplatesApi,
} from "../../shared/api/prescriptionTemplates";
import { apiError } from "../../shared/api/client";
import { Button } from "@/components/ui/button";
import { PrescriptionTemplateForm } from "./components/PrescriptionTemplateForm";

export function PrescriptionTemplateEditPage() {
  const { id } = useParams<{ id: string }>();
  const query = useQuery({
    queryKey: prescriptionTemplateQueryKeys.detail(id ?? ""),
    queryFn: () => prescriptionTemplatesApi.get(id ?? ""),
    enabled: !!id,
  });
  // Guard AFTER hooks so hook order is stable (Rules of Hooks / React #310).
  if (!id) return <Navigate to="/prescriptions/templates" replace />;

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">
            {query.data ? query.data.name : "Toa thuốc mẫu"}
          </h1>
          <p className="text-sm text-muted-foreground">
            {query.data ? (
              <>
                Mã <span className="font-mono">{query.data.code}</span>
                {query.data.icd10Code && (
                  <>
                    {" "}· ICD-10 <span className="font-mono">{query.data.icd10Code}</span>
                  </>
                )}
                {query.data.diagnosis && <> · {query.data.diagnosis}</>}
              </>
            ) : (
              "Đang tải toa mẫu…"
            )}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button asChild variant="outline">
            <Link to="/prescriptions/templates">
              <ArrowLeft />
              Danh sách
            </Link>
          </Button>
        </div>
      </div>

      {query.isLoading && (
        <p className="text-sm text-muted-foreground">Đang tải…</p>
      )}
      {query.isError && (
        <div className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
          {apiError(query.error).detail}
        </div>
      )}
      {query.data && <PrescriptionTemplateForm mode="edit" initial={query.data} />}
    </div>
  );
}
